/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Service_Type_Group_SportsInputs */

const en_service_type_group_sports = /** @type {(inputs: Service_Type_Group_SportsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sports`)
};

const pl_service_type_group_sports = /** @type {(inputs: Service_Type_Group_SportsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sporty`)
};

/**
* | output |
* | --- |
* | "Sports" |
*
* @param {Service_Type_Group_SportsInputs} inputs
* @param {{ locale?: "en" | "pl" }} options
* @returns {LocalizedString}
*/
export const service_type_group_sports = /** @type {((inputs?: Service_Type_Group_SportsInputs, options?: { locale?: "en" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Service_Type_Group_SportsInputs, { locale?: "en" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pl") return pl_service_type_group_sports(inputs)
	return en_service_type_group_sports(inputs)
});